import { render, staticRenderFns } from "./UpdateReservationForm.vue?vue&type=template&id=4c84590c"
import script from "./UpdateReservationForm.vue?vue&type=script&lang=ts"
export * from "./UpdateReservationForm.vue?vue&type=script&lang=ts"
import style0 from "./UpdateReservationForm.vue?vue&type=style&index=0&id=4c84590c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports